import { ModalTypes } from '../../constants';
import { ModalParams } from '../../interface';

export const OPEN_MODAL = 'modals/OPEN_MODAL';
export const CLOSE_MODAL = 'modals/CLOSE_MODAL';

export type OpenModalType = {
  type: typeof OPEN_MODAL;
  modalType: ModalTypes;
  params: ModalParams;
}

export const openModal = (modalType: ModalTypes, params: ModalParams = {}): OpenModalType => ({
  type: OPEN_MODAL,
  modalType,
  params,
});

export type CloseModalType = {
  type: typeof CLOSE_MODAL;
  afterCallback?: Function;
}

export const closeModal = (afterCallback?: Function): CloseModalType => ({
  type: CLOSE_MODAL,
  afterCallback,
});

export type Action = OpenModalType | CloseModalType
